import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import CashFlowLogsPaginatedGql from '@/extensions/shop/pointOfSale/store/graphql/queries/CashFlowLogsPaginated.gql';
import CashFlowLogDatesGql from '@/extensions/shop/pointOfSale/store/graphql/queries/CashFlowLogDates.gql';
import CreateCashFlowLogGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/CreateCashFlowLog.gql';

// import { parseInt } from 'lodash';

export default {
    fetchCashFlowLogsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: CashFlowLogsPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        // link: _.get(data, 'link.route', '/cash-flow-log/'),
                        filters
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.EX_POS_CashFlowLogsPaginated))
                .catch(err => reject(err));
        }),
    // Lightweight scan that only loads id + created_at over all pages, used to
    // determine which months actually contain cash flow (for the export dialog).
    fetchCashFlowLogDates: data =>
        new Promise(async (resolve, reject) => {
            try {
                let filters = [];
                _.each(data.filters, entry => filters.push(entry));

                const perPage = 1000;
                let currentPage = 1;
                let timestamps = [];
                let total = 0;

                do {
                    const { data: response } = await apolloClient.query({
                        query: CashFlowLogDatesGql,
                        variables: { currentPage, perPage, filters },
                        fetchPolicy: 'no-cache',
                    });

                    const payload = response.EX_POS_CashFlowLogsPaginated;
                    const items = _.get(payload, 'items', []) || [];
                    timestamps = timestamps.concat(items.map(item => item.created_at));
                    total = _.get(payload, 'pageInfo.total', timestamps.length);
                    currentPage++;
                } while (timestamps.length < total && currentPage <= 1000);

                resolve(timestamps);
            } catch (err) {
                reject(err);
            }
        }),

    // Loads all cash flow logs matching the current filters (over all pages) so the
    // export can be generated client-side. There is no backend export mutation, so we
    // reuse the existing paginated query and accumulate the items.
    fetchCashFlowLogsForExport: (data, options = {}) =>
        new Promise(async (resolve, reject) => {
            try {
                let filters = [];
                _.each(data.filters, entry => filters.push(entry));

                // Optional month selected in the export dialog overrides any existing
                // created_at filter.
                if (options.dateFilter && (options.dateFilter.from || options.dateFilter.to)) {
                    filters = filters.filter(entry => entry.key !== 'created_at');
                    filters.push({
                        key: 'created_at',
                        match: '',
                        like: '',
                        from: options.dateFilter.from || '',
                        to: options.dateFilter.to || '',
                        in: [],
                    });
                }

                const perPage = 500;
                let currentPage = 1;
                let items = [];
                let total = 0;

                do {
                    const { data: response } = await apolloClient.query({
                        query: CashFlowLogsPaginatedGql,
                        variables: {
                            currentPage,
                            perPage,
                            order: _.get(data, 'variables.order', 'created_at'),
                            direction: _.get(data, 'variables.direction', 'desc'),
                            filters,
                        },
                        fetchPolicy: 'no-cache',
                    });

                    const payload = response.EX_POS_CashFlowLogsPaginated;
                    items = items.concat(_.get(payload, 'items', []) || []);
                    total = _.get(payload, 'pageInfo.total', items.length);
                    currentPage++;
                } while (items.length < total && currentPage <= 1000);

                resolve(items);
            } catch (err) {
                reject(err);
            }
        }),

    create: cashFlowLog => {
        if (cashFlowLog === undefined) throw new Error('required argument is missing');

        cashFlowLog = _.removeDeepByKey(cashFlowLog, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCashFlowLogGql,
                    variables: { cashFlowLog }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_POS_CreateCashFlowLog);
                })
                .catch(err => reject(err));
        });
    },
};
